import { render, staticRenderFns } from "./global-headcount.vue?vue&type=template&id=4f5a4a9a&scoped=true&"
import script from "./global-headcount.vue?vue&type=script&lang=js&"
export * from "./global-headcount.vue?vue&type=script&lang=js&"
import style0 from "./global-headcount.vue?vue&type=style&index=0&id=4f5a4a9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5a4a9a",
  null
  
)

component.options.__file = "global-headcount.vue"
export default component.exports